import { Box, Center, VStack } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import useScreen from "../../hooks/useScreen";
import useSession from "../../hooks/useSession";
// import { Color } from "../../interfaces/HairTransfer";
import { State } from "../../interfaces/State";
import { Channel } from "../../interfaces/tracking";
import { AppDispatch } from "../../reducers/configureStore";
import { setCountClickColor } from "../../reducers/global/globalSlice";
import {
  setSelectedSubColor,
  setShowSmallLoader,
} from "../../reducers/volume/volumeSlice";
import { Analytics, EventNames } from "../../utils/tracking";
import { RotatingDots } from "../RotatingDots/RotatingDots";

export interface ColorItemProps {
  color: any;
  selected: boolean;
  colorList: any;
  screen: string;
  disable?: boolean;
  isByColor?: boolean;
}

export const ColorItem = (props: ColorItemProps) => {
  const { color, selected, screen, disable, isByColor } = props;
  const { isMobile } = useScreen();
  const { isLoggedIn } = useSession();
  const dispatch = useDispatch<AppDispatch>();
  const { countClickColor } = useSelector((state: State) => state.global);
  const { selectedSubColor } = useSelector((state: State) => state.volume);
  const platform: string =
    new URLSearchParams(location.search).get("platform") ?? "";
  const onHandleClick = () => {
    dispatch(setShowSmallLoader(true));
    dispatch(setSelectedSubColor(color));
    const order = countClickColor + 1;

    Analytics.event(Channel.GA, EventNames.COLOR_SELECTED, {
      device: platform.includes("g-mob")
        ? "app"
        : isMobile
        ? "mobile"
        : "desktop",
      name: color?.id,
      position: color?.position,
      order: order,
      type: isByColor ? "color" : "brand",
      login: isLoggedIn(),
    });

    const { product } = selectedSubColor;
    const colorOrBrand = isByColor ? "color" : "brand";

    Analytics.event(Channel.TEALIUM, EventNames.SELECT_CONTENT, {
      page_name: "hair color try on",
      page_type: "virtual try-on",
      page_group: "virtual try-on",
      component_title: `${colorOrBrand} click`,
      action_type: "button",
      action_label: color?.name,
      tryon_hair_color: selectedSubColor.id,
      product_id: [`${product.id}`],
      product_sku: [`${product.sku}`],
      product_name: [`${product.productName}`],
      product_brand: [`${product.brandName}`],
      product_variant_color: [`${product.colorName}`],
    });
    dispatch(setCountClickColor(order));
  };

  return (
    <Box
      as={VStack}
      alignItems="center"
      cursor="pointer"
      onClick={disable ? () => {} : onHandleClick}
      paddingTop="4px"
      paddingBottom="4px"
      paddingRight="3%"
      width="wrap-content"
      height="wrap-content"
      display={"flex"}
      _hover={
        !disable
          ? {
              transform: "scale(1.05)",
              transition: "transform 0.25s",
            }
          : undefined
      }
    >
      <Center
        border={selected ? "1px solid #505050" : "1px solid #E6E6E6"}
        borderRadius="full"
        display={"flex"}
      >
        <Center
          bgImage={
            color.product.swatchImage ? `url(${color.product.swatchImage})` : ""
          }
          border={"3px solid #FFFFFF"}
          bgSize={color.product.swatchImage ? "100%" : { base: 30, md: 40 }}
          bgColor={color.hex}
          bgPosition="center"
          bgRepeat="no-repeat"
          borderRadius="full"
          opacity={disable ? 0.5 : undefined}
          height={isMobile ? "42px" : "62px"}
          width={isMobile ? "42px" : "62px"}
        ></Center>
        {disable && (
          <Box
            position="absolute"
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <RotatingDots isSmall={true} />
          </Box>
        )}
      </Center>
    </Box>
  );
};
